import React, { useEffect, useRef, useState } from 'react';
import Navbar from "../../Utils/Navbar/navbar-component.js";
import Footer from "../../Utils/Footer/footer-component.js";
import Cookies from 'js-cookie';
import idanCover from '../../Assets/ai-gen-studio.png'
import { Modal } from '../../Utils/Modal/modal-component.js';
import * as authActions from '../../Redux/Auth/AuthActions';
import * as aiGenActions from '../../Redux/AiGen/AiGenActions.js';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import flagsData from '../../Public/flags-data.js';
import heartLogo from '../../Assets/heart.png';
import '../Login-Screen/Login.css';
import Toast from '../../Utils/Toast/toast-component.js';
import SkeletonImage from '../../Utils/Skeleton/skeleton-image-component.js';
import Countdown from '../../Utils/Counter/counter-component.js';
import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  border: 4px solid #f3f3f3;
  border-top: 4px solid #5262f2;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: ${rotate} 1s linear infinite;
`;

function Poll() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Local States
    const timeoutRef = useRef(null);
    const [currentCountryIndex, setCurrentCountryIndex] = useState(0);
    const [selectedChoice, setSelectedChoice] = useState(null);
    const [userChoices, setUserChoices] = useState(new Map());
    const [animatedPercentages, setAnimatedPercentages] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showModalDonate, setShowModalDonate] = useState(false);
    const [email, setEmail] = useState(Cookies.get('email') || '');

    // Track which image URLs have finished loading.
    const [loadedImages, setLoadedImages] = useState({});

    const duration = 1000; // in ms

    // --- Redux Data ---
    const votesData = useSelector((state) => state.aiGen.votesData || []);

    // Animation for percentages
    const animatePercentages = (choices) => {
        const totalVotes = choices.reduce((sum, choice) => sum + choice.votes, 0);
        const targetPercentages = choices.map(choice =>
            Math.round((choice.votes / totalVotes) * 100)
        );

        // If we already have some animations going, start from the last known percentages
        const startPercentages = animatedPercentages.length
            ? animatedPercentages
            : new Array(choices.length).fill(0);

        let start = null;
        const easeOutExpo = (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t));

        const animate = (timestamp) => {
            if (!start) start = timestamp;
            const elapsed = timestamp - start;
            const progress = Math.min(elapsed / duration, 1);
            const easedProgress = easeOutExpo(progress);

            const newPercentages = startPercentages.map((startVal, index) => {
                const targetVal = targetPercentages[index];
                return Math.round(
                    startVal + (targetVal - startVal) * easedProgress
                );
            });

            setAnimatedPercentages(newPercentages);
            if (progress < 1) requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
    };

    // On next button click
    const handleNext = () => {
        // Clear the timeout if it exists
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null; // Reset the reference
        }

        // Check if this is the last country
        if (currentCountryIndex === votesData.length - 1) {
            setShowModalDonate(true);
            setShowModal(true);
        } else {
            setSelectedChoice(null);
            setAnimatedPercentages([]);
            setCurrentCountryIndex(currentCountryIndex + 1);
        }
    };

    const handleBackHome = (url) => {
        dispatch(authActions.redirectScreen('/home'));
        navigate('/home');

        timeoutRef.current = setTimeout(() => {
            openNewTab(url);
        }, 200);

    };

    function openNewTab(url) {
        window.open(url, '_blank');
    }

    const handleReturn = () => {
        setShowModal(true);
    };

    // Close modals
    const handleModalClose = () => {
        setShowModal(false);
        setShowModalDonate(true);
    };

    // Handle submission of user email & votes
    const handleEmailSubmit = () => {
        const votesToSubmit = Array.from(userChoices.values());
        dispatch(aiGenActions.submitVotes(email, votesToSubmit));
        handleModalClose();
    };

    const handleEmailValidation = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email || !emailRegex.test(email)) {
            alert('Please enter a valid email address.');
        } else {
            handleEmailSubmit();
        }
    };

    // Fetch poll data from backend via Redux
    useEffect(() => {
        dispatch(aiGenActions.fetchImages());
    }, [dispatch]);

    // (1) Preload all images in the background, so that by the time the user sees them,
    // they are hopefully already cached.
    useEffect(() => {
        if (!votesData || votesData.length === 0) return;

        // Collect all image URLs
        const allImageUrls = votesData.flatMap((country) =>
            country.choices.map((choice) => choice.imageUrl)
        );

        // Loop through each image URL and preload
        allImageUrls.forEach((url) => {
            if (loadedImages[url]) return; // Already loaded or in process

            const img = new Image();
            img.src = url;
            img.onload = () => {
                setLoadedImages((prev) => ({
                    ...prev,
                    [url]: true,
                }));
            };
            // In case of an error, you might still want to mark as "loaded" to avoid infinite skeleton
            img.onerror = () => {
                setLoadedImages((prev) => ({
                    ...prev,
                    [url]: true,
                }));
            };
        });
    }, [votesData, loadedImages]);

    // (2) If the user selects a choice
    const handleVote = (choiceVersion) => {
        const updatedVotes = [...votesData];
        const currentCountry = updatedVotes[currentCountryIndex];
        if (!currentCountry) return;

        const choiceIndex = currentCountry.choices.findIndex(
            (choice) => choice.version === choiceVersion
        );
        if (choiceIndex !== -1) {
            currentCountry.choices[choiceIndex].votes += 1;

            const newUserChoices = new Map(userChoices);
            newUserChoices.set(currentCountry.name, {
                name: currentCountry.name,
                title: currentCountry.title,
                version: choiceVersion,
            });
            setUserChoices(newUserChoices);

            setSelectedChoice(choiceVersion);
            animatePercentages(currentCountry.choices);

            // Clear any existing timeout to avoid multiple triggers
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            // Move on after a delay
            timeoutRef.current = setTimeout(() => {
                timeoutRef.current = null; // Reset the reference
                handleNext();
            }, 3000);
        }
    };

    // For countdown logic:
    const targetTime = new Date(
        new Date().setUTCHours(20, 0, 0, 0) + 24 * 60 * 60 * 1000
    ); // Next day at 8 PM GMT

    // Current group from votesData
    const currentCountry = votesData[currentCountryIndex] || { choices: [] };
    const totalVotes = currentCountry.choices.reduce((sum, choice) => sum + choice.votes, 0);

    return (
        <div>
            {/* Toast messages */}
            <Toast />

            {/* Donation Modal */}
            <Modal expand={showModalDonate} timeout={false}>
                <div className="flex flex-col items-center justify-center w-full h-full bg-white dark:bg-black p-6">
                    <div className="flex w-full items-center justify-center flex-row">
                        <div className="flex justify-center">
                            <div className="flex justify-center">
                                <div className="flex shadow-xl rounded-full aspect-[1] align-middle border-none mb-4 mx-4">
                                    <img
                                        alt="..."
                                        src={idanCover}
                                        style={{ objectFit: 'cover' }}
                                        className={`${true ? 'opacity-100' : 'opacity-0'} flex aspect-[1] rounded-full align-middle border-none  lg:h-54 lg:w-54  h-14 w-14 transition-all duration-150 `}
                                    // onLoad={handleImageLoad}
                                    />
                                </div>
                            </div>

                        </div>
                        <h1 className="mb-4 text-2xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl dark:text-white">ai gen studio</h1>

                    </div>
                    <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white text-center">
                        Thank you for supporting us!
                    </h2>
                    <button
                        className="inline-flex justify-center items-center px-5 py-2 mb-4 bg-blue-500 text-white rounded-lg font-medium flex-row transition-all duration-150 hover:bg-blue-700 focus:ring-4 focus:ring-blue-300"
                        onClick={(e)=>{e.preventDefault(); handleBackHome('https://buymeacoffee.com/ai_gen_studio')}}
                    >
                        <img
                            className="mr-2 w-5 h-5 text-gray-400 align-middle justify-center invert"
                            src={heartLogo}
                            alt="Buy Me a Coffee logo"
                        />
                        Buy Me a Coffee
                    </button>
                    <button
                        className="inline-flex justify-center items-center px-5 py-2 bg-gray-300 text-gray-900 rounded-lg dark:bg-gray-700 dark:text-white font-medium transition-all duration-150 hover:bg-gray-400 dark:hover:bg-gray-600"
                        
                        onClick={(e)=>{e.preventDefault(); handleBackHome('https://klingai.com/h5-app/invitation?code=7BTY2AYW9QJG')}}
                        // onClick={(e)=>{e.preventDefault(); handleBackHome('https://ai-gen-studio.com/ref/redirect?url=https://www.rebatesme.com/en/r/qgl6i2?utm_campaign=qgl6i2&utm_medium=group&utm_source=friends')}}
                    >
                        Return Home
                    </button>
                </div>
            </Modal>

            {/* Email Submission Modal */}
            <Modal expand={showModal} timeout={false}>

                <form
                    className="flex flex-col items-center w-full h-full bg-white dark:bg-black justify-center"
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleEmailValidation();
                    }}
                >

                    <div className="flex mt-2 flex-col max-w-[300px] items-center">


                        <h1 className="text-5xl font-bold mb-10 text-gray-900 dark:text-white">
                            One Last Step
                        </h1>

                        <h3 className="text-lg font-medium dark:text-gray-400 text-gray-500">
                            Video will be uploaded in:
                        </h3>
                        <div className="m-4">
                            <Countdown targetTime={targetTime} />
                        </div>
                        <h1 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">
                            Do you want your votes to count?
                        </h1>
                        <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                            Add your email to make your votes count!
                        </p>

                        {/* Email Input */}
                        <input
                            type="email"
                            placeholder="user@company.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="input-component"
                            required
                        />

                        {/* Quick Domain Options */}
                        <div className="flex flex-wrap justify-center my-4 gap-2">
                            {['@gmail.com', '@yahoo.com', '@hotmail.com', '@outlook.com'].map(
                                (domain, idx) => (
                                    <button
                                        key={idx}
                                        type="button"
                                        className="px-3 py-1 text-sm bg-gray-200 dark:bg-gray-700 rounded-lg text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600 transition"
                                        onClick={() =>
                                            setEmail((prev) =>
                                                prev.includes('@')
                                                    ? prev.split('@')[0] + domain
                                                    : prev + domain
                                            )
                                        }
                                    >
                                        {domain}
                                    </button>
                                )
                            )}
                        </div>

                        {/* Buttons */}
                        <div className="flex flex-row justify-center my-2 gap-x-2 w-1/3">
                            <button
                                type="button"
                                className="px-4 py-2 mt-2 border-gray-700 border-2 text-gray-900 rounded-lg dark:text-white"
                                onClick={handleEmailSubmit}
                            >
                                Skip
                            </button>
                            <button
                                type="submit"
                                className="px-4 py-2 mt-2 bg-blue-500 text-white rounded-lg"
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </form>
            </Modal>

            <Navbar />

            <div className="flex flex-col items-center justify-center h-full w-full">
                {/* If no data, show a fallback */}
                {!currentCountry?.name && (
                    <div className="flex flex-col items-center text-center">
                        <h3 className="text-lg font-medium mt-4 dark:text-gray-300 text-gray-600">
                            Check back tomorrow for new voting opportunities.
                        </h3>
                        <div className="mt-6">
                            <h3 className="text-lg font-medium dark:text-gray-400 text-gray-500">
                                Next voting starts in:
                            </h3>
                            <div className="mt-2">
                                <Countdown targetTime={targetTime} />
                            </div>
                            <h2 className="mt-4 text-2xl font-bold dark:text-white text-black">
                                Stay tuned for the next video voting!
                            </h2>
                        </div>
                    </div>
                )}

                {/* If data exists, show poll */}
                {currentCountry?.name && (
                    <>
                        <h2 className="text-4xl font-bold mt-0">
                            <span className="dark:text-blue-500 text-blue-700">
                                {currentCountry.name}{' '}
                                {flagsData.getFlagByCountry(currentCountry.name)}
                            </span>
                            , which is your favorite?
                        </h2>
                        <h3 className="text-md font-normal mt-2 dark:text-gray-400 text-gray-500">
                            Vote for the upcoming video:
                            <span className="dark:text-blue-500 text-blue-700 font-bold">
                                {' ' + currentCountry.title}
                            </span>
                        </h3>

                        {/* Choices */}
                        <div className="grid-item grid grid-cols-2 lg:gap-1 mt-4 lg:flex-row lg:flex">
                            {currentCountry.choices.map((choice, index) => {
                                const percentage = selectedChoice
                                    ? animatedPercentages[index] || 0
                                    : Math.round((choice.votes / totalVotes) * 100);

                                // Check if this image was loaded in the background
                                const isLoaded = !!loadedImages[choice.imageUrl];

                                return (
                                    <div
                                        key={choice.version}
                                        className={`relative lg:mx-2 mb-1 rounded-lg mx-2 mt-2 transition-all duration-400 lg:max-h-full lg:max-w-[380px]
                    ${selectedChoice === choice.version ? 'border-2' : ''}`}
                                        onClick={() =>
                                            !selectedChoice && handleVote(choice.version)
                                        }
                                        style={{
                                            cursor: !selectedChoice ? 'pointer' : 'not-allowed',
                                        }}
                                    >
                                        {/* Actual Image */}
                                        <img
                                            src={choice.imageUrl}
                                            alt="Loaded content"
                                            className="w-full h-full object-cover transition-opacity duration-700 rounded-lg"
                                        />

                                        {/* Skeleton overlay maintains container size */}
                                        <div
                                            className={`
                        absolute inset-0 w-full h-full 
                        flex items-center justify-center 
                        transition-opacity duration-700 
                        ${isLoaded ? 'opacity-0 pointer-events-none' : 'opacity-100'}
                    `}
                                        >
                                            <SkeletonImage />
                                        </div>

                                        {/* Overlay for percentage & votes */}
                                        <div
                                            className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${selectedChoice
                                                ? 'opacity-100'
                                                : 'opacity-0 pointer-events-none'
                                                }`}
                                        >
                                            <div className="absolute inset-0 bg-black bg-opacity-70 flex flex-col items-center justify-center">
                                                <div className="text-white text-5xl font-extrabold mb-1">
                                                    {percentage}%
                                                </div>
                                                <div className="text-blue-400 text-lg font-medium">
                                                    {choice.votes} votes
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {/* Action Buttons (Next / Submit) */}
                        {selectedChoice && (
                            <div className="flex w-1/3 flex-col items-center">
                                {currentCountryIndex < votesData.length - 1 ? (
                                    <>
                                        <button
                                            className="inline-flex w-full justify-center items-center text-base font-bold text-center text-white rounded-lg dark:bg-blue-500 bg-blue-700 dark:hover:bg-blue-700 dark:focus:ring-gray-800 transition-all duration-150 py-3 px-5 my-3 gap-x-2"
                                            onClick={handleNext}
                                        >
                                            Next
                                            <Spinner />
                                        </button>
                                        <button
                                            onClick={handleReturn}
                                            className="w-full flex justify-center text-sm items-center py-3 font-medium text-center text-gray-900 rounded-lg border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800"
                                        >
                                            <svg
                                                className="mr-2 -ml-1 w-5 h-5"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 25 25"
                                                strokeWidth="1.5"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"
                                                />
                                            </svg>
                                            Home
                                        </button>
                                    </>
                                ) : (
                                    <div className="transition-all ease-in-out duration-150">
                                        <p className="text-lg mt-2 text-gray-700 dark:text-gray-400 mb-2">
                                            Thank you for voting!
                                        </p>
                                        <button
                                            className="inline-flex justify-center items-center text-base font-bold text-center text-white rounded-lg dark:bg-blue-600 bg-blue-700 dark:hover:bg-blue-700 dark:focus:ring-blue-800 transition-all duration-150 py-3 px-5"
                                            onClick={() => setShowModal(true)}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}
                    </>
                )}
            </div>
            {/* <Footer /> */}
        </div>
    );
}

export default Poll;